import createClient from "openapi-fetch";
import {paths} from "./v1";

export function apiClient() {
    const token = localStorage.getItem('token')
    return createClient<paths>({
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        baseUrl: process.env.REACT_APP_API_HOST
    })
}